import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { updateProjectSettings } from '@/store/slices/project';
import { getWorkingProject } from '@/store/slices/project/selectors';
import { EventSettings } from '@/types/projects.types';
import useCanUseChannelFeature from '@/utils/use-can-use-channel-features';
import Container from '@ui/container/container';
import OptionalComponent from '@ui/optional-component/optional-component';
import Switch from '@ui/switch/switch';
import Text from '@ui/text/text/text';
import { ChannelFeaturesEnum } from '@/types/feature-flags.types';

const CoursesSettings = () => {
  const dispatch = useAppDispatch();
  const workingProject = useAppSelector(getWorkingProject);

  const coursesEnabled = !!workingProject?.settings.course_enabled;

  const canUseCourses = useCanUseChannelFeature(ChannelFeaturesEnum.courses);

  const toggleCourses = (on: boolean) => {
    if (!workingProject) return null;

    const projectSettings: EventSettings = {
      ...workingProject.settings,
      course_enabled: on,
    };
    dispatch(updateProjectSettings({ event_uuid: workingProject.uuid, settings: projectSettings }));
  };

  return (
    <OptionalComponent display={canUseCourses}>
      <Container background="none" className="flex ai-center margin-b-32">
        <Text className="margin-r-16">Courses</Text>
        <Switch value="courses" on={coursesEnabled} onClick={(_, on) => toggleCourses(on)} />
      </Container>
    </OptionalComponent>
  );
};

export default CoursesSettings;
